export const AppConfig = {
  site_name: 'Legaltech Hub',
  title: 'Legaltech Hub',
  description: 'LegalTechHub v2',
  locale: 'en',
}
